// Load settings
const settings = window?.env;
if (!settings) {
  throw new Error(
    "No settings were configured! Check env.js was loaded correctly."
  );
}

export default settings;
